export default "__VITE_ASSET__BAmREhg1__"